import { render, staticRenderFns } from "./ModalEditEventUrl.vue?vue&type=template&id=96def55e&scoped=true"
import script from "./ModalEditEventUrl.vue?vue&type=script&lang=js"
export * from "./ModalEditEventUrl.vue?vue&type=script&lang=js"
import style0 from "./ModalEditEventUrl.vue?vue&type=style&index=0&id=96def55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96def55e",
  null
  
)

export default component.exports